<h2 mat-dialog-title>Enter report values</h2>

<mat-dialog-content>
  <form [formGroup]="form" class="parameter-form">
    @for (control of controls; track control) {
      <div class="parameter-row">
        @if (control.finiteOptionSource && !control.multiple) {
          <mat-form-field appearance="outline">
            <mat-label>{{ control.label }}</mat-label>
            <mat-select [formControlName]="control.key">
              @for (option of control.options; track option) {
                <mat-option [value]="option.value">
                  {{ option.label }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (control.finiteOptionSource && control.multiple) {
          <mat-form-field appearance="outline">
            <mat-label>{{ control.label }}</mat-label>
            <mat-select multiple [formControlName]="control.key">
              @for (option of control.options; track option) {
                <mat-option [value]="option.value">
                  {{ option.label }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (!control.finiteOptionSource && control.type !== 'boolean' && !control.multiple) {
          <mat-form-field appearance="outline">
            <mat-label>{{ control.label }}</mat-label>
            <input matInput [type]="control.type === 'number' ? 'number' : control.type === 'date' ? 'date' : control.type === 'datetime' ? 'datetime-local' : 'text'" [formControlName]="control.key" />
          </mat-form-field>
        }
        @if (!control.finiteOptionSource && control.multiple) {
          <mat-form-field appearance="outline">
            <mat-label>{{ control.label }}</mat-label>
            <textarea matInput rows="3" [formControlName]="control.key"></textarea>
          </mat-form-field>
        }
        @if (!control.finiteOptionSource && control.type === 'boolean') {
          <mat-form-field appearance="outline">
            <mat-label>{{ control.label }}</mat-label>
            <mat-select [formControlName]="control.key">
              <mat-option value="true">True</mat-option>
              <mat-option value="false">False</mat-option>
            </mat-select>
          </mat-form-field>
        }
      </div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="submit()">Run report</button>
</mat-dialog-actions>
